export default __webpack_public_path__ + "static/media/cksk.261925d9.svg";